import { render, staticRenderFns } from "./integral-rule.vue?vue&type=template&id=313f44fe&scoped=true&"
import script from "./integral-rule.vue?vue&type=script&lang=js&"
export * from "./integral-rule.vue?vue&type=script&lang=js&"
import style0 from "./integral-rule.vue?vue&type=style&index=0&id=313f44fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313f44fe",
  null
  
)

component.options.__file = "integral-rule.vue"
export default component.exports